import { required } from 'vuelidate/lib/validators';
import { zipCode } from '@/forms/Validations/CommonRules';
import BaseValidation from '@/forms/Validations/BaseValidation';
import { names } from './FindTravelAgentModule.types';

const zipValidation = new BaseValidation([
  {
    name: names.Zip,
    rules: { required, zipCode },
    messages: {
      required: 'Enter zip code',
      zipCode: 'Enter a valid zip code',
    },
  },
]);

const validations = [zipValidation];

export default () => ({
  validations: BaseValidation.getRules(validations),
  messages: BaseValidation.getMessages(validations),
  model: BaseValidation.getModel(validations),
});
